// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewHeader_root__1TwYg"};